// extracted by mini-css-extract-plugin
module.exports = {"DefaultTheme__bar-chart___NTURZ":"DefaultTheme__bar-chart___NTURZ"};